/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, g as getElement } from './index-ef0fa435.js';

const Weather = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.output = createEvent(this, "output", 7);
    this.request = createEvent(this, "request", 7);
    this.icon = 'cloud';
    this.color = 'primary';
    this.colorModal = undefined;
    this.colorInputs = undefined;
    this.colorIconSmall = undefined;
    this.hideTitles = undefined;
    this.supTitle = undefined;
    this.subTitle = undefined;
    this.log = false;
    this.mainTitle = undefined;
    this.nodeSize = 'default';
    this.dataIn = {};
    this.loading = true;
  }
  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node');
    this.output.emit();
  }
  /**
   * Larva error input
   */
  async error(data) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Input Larva event message (see abow)
   */
  async input(data) {
    this.loading = false;
    this.dataIn = data;
  }
  render() {
    const compnentProps = {
      data: this.dataIn,
    };
    const value = this.dataIn.temperature !== undefined ? `${String(this.dataIn.temperature)}°` : null;
    const icon = this.dataIn.icon ? this.dataIn.icon : this.icon;
    return [
      h("lar-node", { icon: icon, hideTitles: this.hideTitles, color: this.color, supTitle: this.supTitle, mainTitle: this.mainTitle, subTitle: this.subTitle, colorModal: this.colorModal, colorInputs: this.colorInputs, colorIconSmall: this.colorIconSmall, log: this.log, value: value, loading: this.loading, nodeSize: this.nodeSize, component: "lar-weather-content", componentProps: compnentProps }, h("slot", null))
    ];
  }
  get el() { return getElement(this); }
};

export { Weather as lar_weather };

//# sourceMappingURL=lar-weather.entry.js.map